/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteRouteImport } from './routes/_layout/route'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutCabinetRouteRouteImport } from './routes/_layout/cabinet/route'
import { Route as LayoutCabinetIndexRouteImport } from './routes/_layout/cabinet/index'
import { Route as LayoutAuthIndexRouteImport } from './routes/_layout/auth/index'
import { Route as LayoutApplicationIndexRouteImport } from './routes/_layout/application/index'
import { Route as LayoutCabinetSchedulesRouteImport } from './routes/_layout/cabinet/schedules'
import { Route as LayoutCabinetProfileRouteImport } from './routes/_layout/cabinet/profile'
import { Route as LayoutCabinetApplicationsRouteImport } from './routes/_layout/cabinet/applications'

const LayoutRouteRoute = LayoutRouteRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutCabinetRouteRoute = LayoutCabinetRouteRouteImport.update({
  id: '/cabinet',
  path: '/cabinet',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutCabinetIndexRoute = LayoutCabinetIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutCabinetRouteRoute,
} as any)
const LayoutAuthIndexRoute = LayoutAuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutApplicationIndexRoute = LayoutApplicationIndexRouteImport.update({
  id: '/application/',
  path: '/application/',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutCabinetSchedulesRoute = LayoutCabinetSchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => LayoutCabinetRouteRoute,
} as any)
const LayoutCabinetProfileRoute = LayoutCabinetProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => LayoutCabinetRouteRoute,
} as any)
const LayoutCabinetApplicationsRoute =
  LayoutCabinetApplicationsRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => LayoutCabinetRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/cabinet': typeof LayoutCabinetRouteRouteWithChildren
  '/': typeof LayoutIndexRoute
  '/cabinet/applications': typeof LayoutCabinetApplicationsRoute
  '/cabinet/profile': typeof LayoutCabinetProfileRoute
  '/cabinet/schedules': typeof LayoutCabinetSchedulesRoute
  '/application': typeof LayoutApplicationIndexRoute
  '/auth': typeof LayoutAuthIndexRoute
  '/cabinet/': typeof LayoutCabinetIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof LayoutIndexRoute
  '/cabinet/applications': typeof LayoutCabinetApplicationsRoute
  '/cabinet/profile': typeof LayoutCabinetProfileRoute
  '/cabinet/schedules': typeof LayoutCabinetSchedulesRoute
  '/application': typeof LayoutApplicationIndexRoute
  '/auth': typeof LayoutAuthIndexRoute
  '/cabinet': typeof LayoutCabinetIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteRouteWithChildren
  '/_layout/cabinet': typeof LayoutCabinetRouteRouteWithChildren
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/cabinet/applications': typeof LayoutCabinetApplicationsRoute
  '/_layout/cabinet/profile': typeof LayoutCabinetProfileRoute
  '/_layout/cabinet/schedules': typeof LayoutCabinetSchedulesRoute
  '/_layout/application/': typeof LayoutApplicationIndexRoute
  '/_layout/auth/': typeof LayoutAuthIndexRoute
  '/_layout/cabinet/': typeof LayoutCabinetIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/cabinet'
    | '/'
    | '/cabinet/applications'
    | '/cabinet/profile'
    | '/cabinet/schedules'
    | '/application'
    | '/auth'
    | '/cabinet/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cabinet/applications'
    | '/cabinet/profile'
    | '/cabinet/schedules'
    | '/application'
    | '/auth'
    | '/cabinet'
  id:
    | '__root__'
    | '/_layout'
    | '/_layout/cabinet'
    | '/_layout/'
    | '/_layout/cabinet/applications'
    | '/_layout/cabinet/profile'
    | '/_layout/cabinet/schedules'
    | '/_layout/application/'
    | '/_layout/auth/'
    | '/_layout/cabinet/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRouteRoute: typeof LayoutRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/cabinet': {
      id: '/_layout/cabinet'
      path: '/cabinet'
      fullPath: '/cabinet'
      preLoaderRoute: typeof LayoutCabinetRouteRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/cabinet/': {
      id: '/_layout/cabinet/'
      path: '/'
      fullPath: '/cabinet/'
      preLoaderRoute: typeof LayoutCabinetIndexRouteImport
      parentRoute: typeof LayoutCabinetRouteRoute
    }
    '/_layout/auth/': {
      id: '/_layout/auth/'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof LayoutAuthIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/application/': {
      id: '/_layout/application/'
      path: '/application'
      fullPath: '/application'
      preLoaderRoute: typeof LayoutApplicationIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/cabinet/schedules': {
      id: '/_layout/cabinet/schedules'
      path: '/schedules'
      fullPath: '/cabinet/schedules'
      preLoaderRoute: typeof LayoutCabinetSchedulesRouteImport
      parentRoute: typeof LayoutCabinetRouteRoute
    }
    '/_layout/cabinet/profile': {
      id: '/_layout/cabinet/profile'
      path: '/profile'
      fullPath: '/cabinet/profile'
      preLoaderRoute: typeof LayoutCabinetProfileRouteImport
      parentRoute: typeof LayoutCabinetRouteRoute
    }
    '/_layout/cabinet/applications': {
      id: '/_layout/cabinet/applications'
      path: '/applications'
      fullPath: '/cabinet/applications'
      preLoaderRoute: typeof LayoutCabinetApplicationsRouteImport
      parentRoute: typeof LayoutCabinetRouteRoute
    }
  }
}

interface LayoutCabinetRouteRouteChildren {
  LayoutCabinetApplicationsRoute: typeof LayoutCabinetApplicationsRoute
  LayoutCabinetProfileRoute: typeof LayoutCabinetProfileRoute
  LayoutCabinetSchedulesRoute: typeof LayoutCabinetSchedulesRoute
  LayoutCabinetIndexRoute: typeof LayoutCabinetIndexRoute
}

const LayoutCabinetRouteRouteChildren: LayoutCabinetRouteRouteChildren = {
  LayoutCabinetApplicationsRoute: LayoutCabinetApplicationsRoute,
  LayoutCabinetProfileRoute: LayoutCabinetProfileRoute,
  LayoutCabinetSchedulesRoute: LayoutCabinetSchedulesRoute,
  LayoutCabinetIndexRoute: LayoutCabinetIndexRoute,
}

const LayoutCabinetRouteRouteWithChildren =
  LayoutCabinetRouteRoute._addFileChildren(LayoutCabinetRouteRouteChildren)

interface LayoutRouteRouteChildren {
  LayoutCabinetRouteRoute: typeof LayoutCabinetRouteRouteWithChildren
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutApplicationIndexRoute: typeof LayoutApplicationIndexRoute
  LayoutAuthIndexRoute: typeof LayoutAuthIndexRoute
}

const LayoutRouteRouteChildren: LayoutRouteRouteChildren = {
  LayoutCabinetRouteRoute: LayoutCabinetRouteRouteWithChildren,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutApplicationIndexRoute: LayoutApplicationIndexRoute,
  LayoutAuthIndexRoute: LayoutAuthIndexRoute,
}

const LayoutRouteRouteWithChildren = LayoutRouteRoute._addFileChildren(
  LayoutRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  LayoutRouteRoute: LayoutRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
